// DI   10TW-003

window.initQuickAddButtons = function() {
  const quickAddButtons = document.querySelectorAll('.quick-add-button, .quick-add-button-text');
  
  quickAddButtons.forEach(button => {
    if (button.dataset.initialized === 'true') return;
    
    button.dataset.initialized = 'true';
    
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = button.dataset.variantId;
      const redirectToPdp = button.dataset.redirectToPdp === 'true';
      const productUrl = button.dataset.productUrl;
      
      if (!variantId || button.disabled) return;
      
      if (redirectToPdp && productUrl) {
        window.location.href = productUrl;
        return;
      }
      
      button.disabled = true;
      button.classList.add('loading');
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
        
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        
        const data = await response.json();
        
        button.classList.remove('loading');
        button.classList.add('product-added');
        
        const cartCountElements = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            cartCountElements.forEach(el => {
              el.textContent = cart.item_count;
            });
          });
        
        setTimeout(() => {
          button.classList.remove('product-added');
          button.disabled = false;
        }, 2000);
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.classList.remove('loading');
        button.disabled = false;
        alert('Failed to add product to cart. Please try again.');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', window.initQuickAddButtons);
